import { render, staticRenderFns } from "./CoinPurse.vue?vue&type=template&id=7fe5aa9f&scoped=true&"
import script from "./CoinPurse.vue?vue&type=script&lang=js&"
export * from "./CoinPurse.vue?vue&type=script&lang=js&"
import style0 from "./CoinPurse.vue?vue&type=style&index=0&id=7fe5aa9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe5aa9f",
  null
  
)

export default component.exports